import { render, staticRenderFns } from "./NordLatestPublicationsBlock.vue?vue&type=template&id=38ee4b37&"
import script from "./NordLatestPublicationsBlock.vue?vue&type=script&lang=js&"
export * from "./NordLatestPublicationsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ee4b37')) {
      api.createRecord('38ee4b37', component.options)
    } else {
      api.reload('38ee4b37', component.options)
    }
    module.hot.accept("./NordLatestPublicationsBlock.vue?vue&type=template&id=38ee4b37&", function () {
      api.rerender('38ee4b37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/blocks/NordLatestPublicationsBlock.vue"
export default component.exports